// @ts-ignore
import styles from './styles.module.css'

const GettingStarted: React.FC = () => {
    return (
        <div>
            <div className={styles.title}>Getting Started</div>
            <div>
                <div className={styles.subTitle2}>
                    How to Obtain an API Key Through SoftNote Passport
                </div>
                <div className={styles.text}>
                    Follow these steps to obtain your API key for developers via
                    Passport.
                </div>
                <div className={styles.subTitle}>Steps</div>
                <ol className={styles.list}>
                    <li className={styles.item}>
                        <div className={styles.itemTitle}>
                            Authorization in Passport
                        </div>
                        <div className={styles.itemBody}>
                            First, log in to your Passport account. This is the
                            authorization step that confirms you have the
                            required permissions to generate an API key.
                        </div>
                    </li>
                    <li className={styles.item}>
                        <div className={styles.itemTitle}>
                            Navigate to Developer Section
                        </div>
                        <div className={styles.itemBody}>
                            Once logged in and on the main page, scroll down
                            until you see a section specifically for developers
                        </div>
                    </li>
                    <li className={styles.item}>
                        <div className={styles.itemTitle}>
                            Locate Generate API Key Button
                        </div>
                        <div className={styles.itemBody}>
                            Within the developers section, you will find a
                            button labeled "Generate API key."
                        </div>
                    </li>
                    <li className={styles.item}>
                        <div className={styles.itemTitle}>
                            Click to Generate API Key
                        </div>
                        <div className={styles.itemBody}>
                            Click on the "Generate API key" button to proceed.
                        </div>
                    </li>
                    <li className={styles.item}>
                        <div className={styles.itemTitle}>
                            Retrieve Permanent Key
                        </div>
                        <div className={styles.itemBody}>
                            Upon clicking, a new page will appear displaying
                            your permanent API key. Make sure to save this key
                            securely, as you will use it for API-related tasks.
                        </div>
                    </li>
                </ol>

                <div className={styles.subTitle}>Important Note</div>
                <div className={styles.text}>
                    Your API key is sensitive information. Do not share it and
                    keep it secure.
                </div>
                <div className={styles.text}>
                    That's it! You've successfully obtained your API key through
                    Passport.
                </div>
            </div>
        </div>
    )
}

export default GettingStarted
